export default function textUppercase(str) {
    if (!str) return "";
    return str.toUpperCase();
}